var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEffortlessSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.47 21.7002C63.92 18.1502 67.79 10.2502 58.59 9.29023C48 8.20023 47.05 2.37023 41.47 2.86023C34.23 3.49023 36.21 11.3702 27.8 11.5102C20.01 11.6402 19.38 14.5702 19.49 20.3202C19.67 29.2502 13.71 30.5202 14.39 36.3202C14.76 39.4502 19.39 42.3202 21.59 44.3902C28.22 50.8102 25.05 54.3302 28.59 57.3902C32.13 60.4502 37.28 56.1402 42.53 56.1302C49.37 56.1302 51.81 59.1302 57.07 57.8502C62.33 56.5702 63.15 50.2002 64.75 45.5602C66.08 41.6802 72.41 39.9202 71.95 33.3102C71.43 26.4002 67.89 27.2302 65.47 21.7002Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1002 50.3503L17.5302 63.0003C14.1502 66.6403 20.3202 71.8703 23.3602 67.6303L34.2702 49.5303",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1299 51.4101C54.0485 51.4101 62.8999 42.5588 62.8999 31.6401C62.8999 20.7214 54.0485 11.8701 43.1299 11.8701C32.2112 11.8701 23.3599 20.7214 23.3599 31.6401C23.3599 42.5588 32.2112 51.4101 43.1299 51.4101Z",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1299 33.1703C43.9749 33.1703 44.6599 32.4853 44.6599 31.6404C44.6599 30.7954 43.9749 30.1104 43.1299 30.1104C42.2849 30.1104 41.5999 30.7954 41.5999 31.6404C41.5999 32.4853 42.2849 33.1703 43.1299 33.1703Z",
    fill: "#00005A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 18.6602C38.7427 18.9317 35.7072 20.4203 33.4982 22.8295C31.2892 25.2386 30.0687 28.3916 30.08 31.6602",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1301 44.6799C46.46 44.6847 49.6648 43.4116 52.0836 41.123C54.5024 38.8344 55.9508 35.7049 56.1301 32.3799",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.21 30.1497H50.28C49.9754 28.7015 49.2389 27.3797 48.1677 26.3585C47.0966 25.3374 45.7411 24.6649 44.28 24.4297V26.4297C45.2075 26.6425 46.0611 27.0997 46.7522 27.7538C47.4433 28.408 47.9467 29.2353 48.21 30.1497ZM48.37 32.3797C48.2205 33.4526 47.7452 34.4537 47.0084 35.2477C46.2716 36.0418 45.3087 36.5905 44.25 36.8197V38.8197C45.8458 38.572 47.3147 37.8029 48.4273 36.6324C49.5399 35.4619 50.2336 33.956 50.4 32.3497L48.37 32.3797ZM36 30.1497H38.07C38.3438 29.232 38.8597 28.405 39.5636 27.7557C40.2675 27.1064 41.1333 26.6587 42.07 26.4597V24.4597C40.6003 24.6798 39.2323 25.3421 38.148 26.3585C37.0638 27.3749 36.3146 28.6972 36 30.1497ZM37.9 32.3797H35.9C36.064 33.9788 36.7504 35.4793 37.8531 36.6489C38.9558 37.8185 40.4133 38.592 42 38.8497V36.8497C40.9408 36.6129 39.9793 36.0577 39.2446 35.2587C38.51 34.4597 38.0373 33.4551 37.89 32.3797H37.9Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 38.02,
    y1: 26.2297,
    x2: 51.86,
    y2: 40.8797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF9793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FF8AA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FF80B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FF66D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4900FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEffortlessSearch);
export default __webpack_public_path__ + "static/media/icon-effortless-search.9e272abc2976758e2c708583aa1b2018.svg";
export { ForwardRef as ReactComponent };